import PaginationLayout from "../components/PaginationLayout";
import profile_placeholder from "../assets/images/profile_placeholder.png";
import { Link, useLocation, useMatch } from "react-router-dom";
import { useParams } from "react-router-dom";
import React, { useContext, useEffect, useState } from "react";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import moment from "moment";

export default () => {
  const location = useLocation();
  let limit = 10;
  const match =useMatch("/transaction/:page")
  const { authState ,handleError, handlePagination, handleFilter} = useContext(GlobalContext);
  const param = useParams();
  const newParam = new URLSearchParams(location.search);
  var query = new URLSearchParams(location.search);

  const [pageData, setPageData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [searchData, setSearchData] = useState("");

  henceforthApi.setToken(authState.access_token);

  const init = async () => {
    setLoading(true);
    let searchData = newParam.has("search") ? newParam.get("search") : null;
    setSearchData(searchData);
    try {
      let q = query.toString();
      let apiRes = await henceforthApi.Transaction.getPagnation(
        Number(match.params.page)-1,
        limit,
      newParam.get("filter").toString()
      );
      setPageData(apiRes);
      setTotalCount(apiRes.count);

      setLoading(false);
    } catch (error) {
      handleError(error)
      setLoading(false);
      setPageData([]);
    }
  };

  //Pagination
  // const onChangePagination = (newVal) => {
  //   const newParam = new URLSearchParams(location.search);
  //     navigate(`/transaction/${newVal}?filter=${newParam.get("filter")}`);
  // };
  //Search
  // const onSearch = async (searchData) => {
  //   if (searchData) {
  //     navigate(`/transaction/1?search=${searchData}`);
  //   } else {
  //     navigate(`/transaction/1`);
  //   }
  // };
  //Activate And Deactivate
  // const [manageUsers, setManageUsers] = useState({
  //   type: "",
  //   _id: "",
  //   admin_verified: false,
  //   language: "ENGLISH",
  //   account_status: "",
  // });
  

  //Filter
  const filters = [
    { name: "All Transaction", value: "SEND" },
    { name: "Withdraw", value: "WITHDRAW" },
  ];
  // const onFilterApply = (name, value) => {
  //   onChangePagination();
  //   setLoading(true);
  //   if (query.has(name)) {
  //     let queryValue = query.get(name);
  //     // if (queryValue == value) {
  //     if (value === "") {
  //       query.delete(name);
  //     } else {
  //       query.set(name, value);
  //     }
  //   } else {
  //     query.set(name, value);
  //   }
  //   navigate({ pathname: `/transaction/1`, search: query.toString() }, { replace: true });
  // };

  useEffect(() => {
    init();
  }, [match.params.page, query.get("filter"), newParam.get("search")]);
 
  return (
    <>
      <div className="ibox animated fadeInRight">
        <div
          className="ibox-title d-flex align-items-center justify-content-between"
          style={{ color: "#000000" }}
        >
          <h5 style={{ fontSize: "16px" }} className="m-0 fw-bold">
            List of all { (newParam.get("filter") == "SEND" || newParam.get("filter") == "" ) ? "Transaction" :"Withdraw"}
          </h5>
          <div className="dropdown theme me-3">
            <button
              className="btn dashboard-button pe-4 ps-4 dropdown-toggle shadow-none"
              id="sortDropdown"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              {filters.filter((res) => res.value == query.get("filter")).length
                ? filters.filter((res) => res.value === query.get("filter"))[0]
                  .name
                : "All ransaction"}
              {/* <i
                className="fas fa-chevron-down bi-chevron-down ms-2 "
                style={{ fontSize: "12px" }}
              ></i> */}
            </button>
            <ul
              className="dropdown-menu share-icons"
              aria-labelledby="sortDropdown"
            >
              {query.has("filter") && (
                <li className="cursor-pointer">
                  <a
                    className="dropdown-item"
                    onClick={() => handleFilter("filter", "")}
                  >
                    {/* All Transaction */}
                  </a>
                </li>
              )}
              {filters.map((res) => {
                return (
                  <li key={res.value} className="cursor-pointer">
                    <a
                      className="dropdown-item"
                      onClick={() => handleFilter("filter", res.value)}
                    >
                      {res.name}
                    </a>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>
        <div
          className="ibox-title d-flex align-items-center justify-content-between"
          style={{ color: "#000000" }}
        >
         
          <div className="theme me-3 fs-20">
           Total earning : <b> {pageData?.total_earning ? `$${pageData?.total_earning?.toFixed(2)}` : "Not Available"}</b>
          </div>
          <div className="theme me-3 fs-20">
          Available  Balance :<b> {pageData?.total_earning ? `$${pageData?.total_earning?.toFixed(2)}` : "Not Available"}</b>
          </div>
        </div>
        <div className="ibox-content">
          {/* <form
            onSubmit={(e) => {
              e.preventDefault();
            }}
          >
            <div class="input-group form-group">
              <input
                value={searchData}
                name="searchInput"
                onChange={(e) => {
                  setSearchData(e.target.value);
                  onSearch(e.target.value);
                }}
                placeholder="Search by  Email"
                type="text"
                className="form-control form-control-sm "
                style={{ paddingBlock: "16px" }}
              />{" "}
              <span class="input-group-append">

              </span>
            </div>
          </form> */}
          {(newParam.get("filter") == "SEND" || newParam.get("filter") == "" ) ?
          <div className="table-responsive">
            <table className="table table-striped">
              <thead>
                <tr style={{ color: "#000000", fontSize: "14px" }}>
                  <th>Sr. No.</th>
                  <th>Sent by</th>
                  {/* <th>Email</th> */}
                  <th>Sent to</th>
                  {/* <th>Email</th> */}
                  <th>Date & Time</th>
                  <th>User received coins</th>
                  {/* <th>Phone Number</th>
                  <th>Status </th>
                  <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                 {!loading && !pageData?.data?.length ? <tr> <td colSpan={5} className="text-center">No transaction available</td> </tr> : pageData?.data?.map((res, index) => (
                  <tr style={{ fontSize: "14px" }} key={res._id}>
                    <td>
                      {param.page === "0"
                        ? index + 1
                        : (param.page - 1) * limit + (index + 1)}
                      .
                    </td>
                  
                    <td className="justify-content-center" style={{cursor:"pointer"}}>
                    <Link to ={`/user/${res?.sender_id?._id}/1/1?type=posts`} className="link-colour">
                    {res?.sender_id ? res?.sender_id?.full_name : res?.sender_id?.email ? res?.sender_id?.email : "Not Available"}
                    </Link>
                    </td>
                   
                    {/* <td className="justify-content-center">
                    mohit@yopmail.com
                    </td> */}
                     
                    <td  style={{cursor:"pointer"}}>
                    <Link to ={`/user/${res?.reciever_id?._id}/1/1?type=posts`} className="link-colour" >
                    {res?.reciever_id ? res?.reciever_id?.full_name : res?.reciever_id?.email ? res?.reciever_id?.email: "Not Available"}
                    </Link>
                    </td>
                 
                    {/* <td className="justify-content-center">
                    rohan@yopmail.com
                    </td> */}
                    <td>{res?.created_at ? moment(Number(res?.created_at)).format("DD MMM YYYY , hh:mm a")?.toUpperCase() : "Not available"}</td>
                    <td>{res?.coins ? `$${res?.coins}` : "Not Available"}</td>
                  
                  </tr>
                ))} 
              </tbody>
            </table>
          </div> :
          <>
{/* <div><b>List of all Withdraw</b></div> */}
          {/* 2 nd table  */}
          <div className="table-responsive mt-4">
            <table className="table table-striped">
              <thead>
                <tr style={{ color: "#000000", fontSize: "14px" }}>
                  <th>Sr. No.</th>
                  <th>Withdraw By</th>
                  {/* <th>Email</th> */}
                  <th>Amount withdrawn</th>
                  <th>App commissionn</th>
                  <th>Date & Time</th>
                  <th>Total Withdraw</th>
                  {/* <th>Date & Time</th> */}
                  {/* <th>Phone Number</th>
                  <th>Status </th>
                  <th>Action</th> */}
                </tr>
              </thead>
              <tbody>
                {!loading && !pageData?.data?.length ? <tr> <td colSpan={6} className="text-center">No transaction available</td> </tr> : pageData?.data?.map((res, index) =>  <tr style={{ fontSize: "14px" }} >
                <td>
                      {param.page === "0"
                        ? index + 1
                        : (param.page - 1) * limit + (index + 1)}
                      .
                    </td>
                    <td  style={{cursor:"pointer"}}>
                    <Link to ={`/user/${res?.reciever_id?._id}/1/1?type=posts`} className="link-colour" >
                    {res?.reciever_id ? res?.reciever_id?.full_name : res?.reciever_id?.email ? res?.reciever_id?.email: "Not Available"}
                    </Link>
                    </td>
                    {/* <td className="justify-content-center">
                    mohit@yopmail.com
                    </td> */}
                    <td>
                    {res?.coins ? `$${res?.coins}` : "Not Available"}
                    </td>
                    <td>${res?.charges ? res?.charges : "Not Available"}</td>
                    <td>{res?.created_at ? moment(Number(res?.created_at)).format("DD MMM YYYY , hh:mm a")?.toUpperCase() : "Not available"}</td>
                    <td> {res?.amount ? `$${res?.amount}`: "Not Available"}</td>
                  </tr> )}                  
                 
                {/* ))} */}
              </tbody>
            </table>
          </div>
          </> }
          <PaginationLayout
            count={pageData?.count}
            data={pageData.data}
            page={Number(match.params.page)}
            limit={Number(limit)}
            loading={loading}
            onPageChange={(val) => handlePagination(val)}
          />
        </div>
      </div>
    </>
  );
};
